import { createAction } from 'redux-actions'
import { Story, StoryPeerType } from '@weblite/ts-action/story'
import { dispatch } from '$setup/redux'
import {
  AddStoryToRibbonPayload,
  AddStoryToStoriesPayload,
  StoryRibbon,
  UpdateUploadData,
  UploadingStory,
} from '$logic/story/types'
import { StoryStorageState } from '$logic/story/storage'

// action
export const SET_RIBBON_DATA = 'SET_RIBBON_DATA'
const setRibbonStoryData = createAction(SET_RIBBON_DATA)
export const dispatchSetRibbonStoryData = ({
  replace,
  payload,
}: {
  replace: boolean
  payload: StoryRibbon[]
}) => dispatch(setRibbonStoryData({ replace, payload }))

export const ADD_STORY_TO_RIBBON = 'ADD_STORY_TO_RIBBON'
const addStoryToRibbon = createAction(ADD_STORY_TO_RIBBON)
export const dispatchAddStoryToRibbon = (data: AddStoryToRibbonPayload) =>
  dispatch(addStoryToRibbon(data))

export const DELETE_STORY_FROM_RIBBON = 'DELETE_STORY_FROM_RIBBON'
const deleteStoryFromRibbon = createAction(DELETE_STORY_FROM_RIBBON)
export const dispatchDeleteStoryFromRibbon = (data: AddStoryToStoriesPayload) =>
  dispatch(deleteStoryFromRibbon(data))

export const SET_STORY_DATA = 'SET_STORY_DATA'
const setStoryData = createAction(SET_STORY_DATA)
export const dispatchSetStoryData = (data: {
  peerId: string
  peerType: StoryPeerType
  stories: Story[]
}) => dispatch(setStoryData(data))

export const ADD_STORY_TO_STORIES = 'ADD_STORY_TO_STORIES'
const addStoryToStories = createAction(ADD_STORY_TO_STORIES)
export const dispatchAddStoryToStories = (data: Story) =>
  dispatch(addStoryToStories(data))

export const DELETE_STORY_FROM_STORIES = 'DELETE_STORY_FROM_STORIES'
const deleteStoryFromStories = createAction(DELETE_STORY_FROM_STORIES)
export const dispatchDeleteStoryFromStories = (
  data: AddStoryToStoriesPayload,
) => dispatch(deleteStoryFromStories(data))

export const CREATE_UPLOADING_DATA = 'CREATE_UPLOADING_DATA'
const createUploadingData = createAction(CREATE_UPLOADING_DATA)
export const dispatchCreateUploadingData = (data: UploadingStory) =>
  dispatch(createUploadingData(data))

export const UPDATE_UPLOADING_DATA = 'UPDATE_UPLOADING_DATA'
const updateUploadingData = createAction(UPDATE_UPLOADING_DATA)
export const dispatchUpdateUploadingData = (data: UpdateUploadData) =>
  dispatch(updateUploadingData(data))

export const DELETE_UPLOADING_DATA = 'DELETE_UPLOADING_DATA'
const deleteUploadingData = createAction(DELETE_UPLOADING_DATA)
export const dispatchDeleteUploadingData = (uploadId: string) =>
  dispatch(deleteUploadingData({ uploadId }))

export const UPDATE_RIBBON_STORY_VIEWED_AT = 'UPDATE_RIBBON_STORY_VIEW'
const updateRibbonStoryViewedAt = createAction(UPDATE_RIBBON_STORY_VIEWED_AT)
export const dispatchUpdateRibbonStoryViewedAt = (
  peerId: string,
  peerType: StoryPeerType,
  storyId: string,
) => dispatch(updateRibbonStoryViewedAt({ peerId, peerType, storyId }))

// export const UPDATE_STORY_RIBBON_VIEWED_ALL = 'UPDATE_STORY_RIBBON_VIEWED_ALL'
// const updateStoryRibbonViewedAll = createAction(UPDATE_STORY_RIBBON_VIEWED_ALL)
// export const dispatchUpdateStoryRibbonViewedAll = (
//   peerId: string,
//   peerType: StoryPeerType,
//   viewedAll: boolean,
// ) => dispatch(updateStoryRibbonViewedAll({ peerId, peerType, viewedAll }))
